import { useQuery } from 'react-query';
import { getCampusHiringApplicationsWithCandidates, getCampusHiringCandidates, getHiringApplicationsGraphData } from 'src/apis/campusHiring';
import {
	GetCampusHiringApplicationsWithCandidatesAPIResponse,
	GetCampusHiringCandidatesAPIResponse,
	GetHiringApplicationsGraphDataAPIResponse,
	UserFiltersForApis,
} from 'types';

export const useGetCampusHiringCandidates = ({
	page,
	limit,
	filters,
	onComplete,
	handleError,
}: {
	page: number;
	limit?: number;
	filters?: UserFiltersForApis;
	onComplete?: (data: GetCampusHiringCandidatesAPIResponse) => void;
	handleError?: () => void;
}) => {
	return useQuery({
		queryKey: ['getCampusHiringCandidates', page, limit, filters],
		queryFn: async () =>
			(await getCampusHiringCandidates({
				page,
				limit,
				...filters,
			})) as GetCampusHiringCandidatesAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetCampusHiringApplicationsWithCandidates = ({
	page,
	limit,
	search,
	filters,
	onComplete,
	handleError,
	hiringAssessment,
}: {
	page: number;
	limit?: number;
	search?: string;
	hiringAssessment?: string;
	filters?: UserFiltersForApis;
	onComplete?: (data: GetCampusHiringApplicationsWithCandidatesAPIResponse) => void;
	handleError?: () => void;
}) => {
	return useQuery({
		queryKey: ['getCampusHiringApplicationsWithCandidates', page, limit, search, hiringAssessment, filters],
		queryFn: async () =>
			(await getCampusHiringApplicationsWithCandidates({
				page,
				limit,
				search,
				...filters,
				hiringAssessment,
			})) as GetCampusHiringApplicationsWithCandidatesAPIResponse,
		staleTime: 0,
		keepPreviousData: true,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetHiringApplicationsGraphData = ({
	page,
	sort,
	limit,
	onComplete,
	handleError,
	hiringAssessment,
}: {
	page: number;
	sort?: string;
	limit?: number;
	hiringAssessment?: string;
	onComplete?: (data: GetHiringApplicationsGraphDataAPIResponse) => void;
	handleError?: () => void;
}) => {
	return useQuery({
		queryKey: ['getHiringApplicationsGraphData', page, limit, hiringAssessment, sort],
		queryFn: async () =>
			(await getHiringApplicationsGraphData({
				page,
				limit,
				sort,
				hiringAssessment,
			})) as GetHiringApplicationsGraphDataAPIResponse,
		staleTime: 0,
		keepPreviousData: true,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
